export enum DashboardAreaCardOrganizationEnum {
  HorizontalList = 0,
  VerticalGrid = 1,
}
